import { render, staticRenderFns } from "./MbPathsModal.vue?vue&type=template&id=448a85d9&scoped=true&"
import script from "./MbPathsModal.vue?vue&type=script&lang=js&"
export * from "./MbPathsModal.vue?vue&type=script&lang=js&"
import style0 from "./MbPathsModal.vue?vue&type=style&index=0&id=448a85d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448a85d9",
  null
  
)

export default component.exports